import { isSupabaseConfigured, supabase } from "../lib/supabase";

const STORAGE_KEY = "almoune_suppliers";

export const defaultSuppliers = [
  {
    id: "supp-1",
    name: "Alimentation Generale Leblanc",
    contact: "Jean-Pierre Leblanc",
    phone: "01 60 00 00 01",
    email: "contact@leblanc-distrib.fr",
    address: "Zone Commerciale Sud, 91000 Evry",
    siret: "12345678900012",
    tva: "FR123456789",
    categories: ["Epicerie", "Boissons", "Produits menagers"],
    paymentTerms: "30 jours",
    notes: "Fournisseur principal, livraison le mardi.",
    active: true,
    createdAt: "2026-01-10T10:00:00Z",
  },
  {
    id: "supp-2",
    name: "Fruits & Legumes Frais Méditerranée",
    contact: "Maria Garcia",
    phone: "04 91 00 00 02",
    email: "commande@flf-med.com",
    address: "MIN Les Arnavaux, 13014 Marseille",
    siret: "",
    tva: "",
    categories: ["Fruits", "Legumes", "Frais"],
    paymentTerms: "Paiement à la livraison",
    notes: "Appeler avant 6h du matin pour livraison le jour meme.",
    active: true,
    createdAt: "2026-01-12T08:30:00Z",
  },
  {
    id: "supp-3",
    name: "Glaces & Surgelés du Nord",
    contact: "Thierry Dubois",
    phone: "03 20 00 00 03",
    email: "commercial@surgeles-nord.fr",
    address: "Z.I. Fretin, 59273 Fretin",
    siret: "",
    tva: "",
    categories: ["Surgeles", "Glaces"],
    paymentTerms: "Fin de mois",
    notes: "Minimum de commande: 250 EUR HT.",
    active: true,
    createdAt: "2026-01-15T14:45:00Z",
  },
];

const normalizeSupplier = (s) => ({
  id: s.id || `supp-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  name: s.name || "",
  contact: s.contact || "",
  phone: s.phone || "",
  email: s.email || "",
  address: s.address || "",
  siret: s.siret || "",
  tva: s.tva || "",
  categories: Array.isArray(s.categories) ? s.categories : [],
  paymentTerms: s.paymentTerms || "",
  notes: s.notes || "",
  active: s.active !== false,
  createdAt: s.createdAt || new Date().toISOString(),
});

const readCache = () => {
  if (typeof window === "undefined") return defaultSuppliers;
  try {
    const data = window.localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : defaultSuppliers;
  } catch (err) {
    console.warn("Failed to read suppliers from localStorage", err);
    return defaultSuppliers;
  }
};

const writeCache = (suppliers) => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(suppliers));
    } catch (err) {
      console.warn("Failed to write suppliers to localStorage", err);
    }
  }
  return suppliers;
};

export const getSuppliers = () => readCache();

export const loadSuppliers = async () => {
  if (!isSupabaseConfigured || !supabase) return readCache();
  try {
    const { data, error } = await supabase
      .from("suppliers")
      .select("*")
      .order("name", { ascending: true });
    
    if (error) throw error;
    if (data) {
      const normalized = data.map((d) => ({
        id: d.id,
        name: d.name,
        contact: d.contact,
        phone: d.phone,
        email: d.email,
        address: d.address,
        siret: d.siret || "",
        tva: d.tva || "",
        categories: d.categories || [],
        paymentTerms: d.payment_terms || "",
        notes: d.notes,
        active: d.active,
        createdAt: d.created_at,
      }));
      return writeCache(normalized);
    }
  } catch (err) {
    console.error("Failed to load suppliers from Supabase:", err.message);
  }
  return readCache();
};

export const saveSupplier = async (supplier) => {
  const normalized = normalizeSupplier(supplier);
  const all = readCache();
  const idx = all.findIndex((s) => s.id === normalized.id);
  const updated = idx >= 0 ? all.map((s, i) => (i === idx ? normalized : s)) : [...all, normalized];
  const saved = writeCache(updated);
  
  if (!isSupabaseConfigured || !supabase) return saved;
  try {
    await supabase.from("suppliers").upsert({
      id: normalized.id,
      name: normalized.name,
      contact: normalized.contact,
      phone: normalized.phone,
      email: normalized.email,
      address: normalized.address,
      siret: normalized.siret,
      tva: normalized.tva,
      categories: normalized.categories,
      payment_terms: normalized.paymentTerms,
      notes: normalized.notes,
      active: normalized.active,
      created_at: normalized.createdAt,
    }, { onConflict: "id" });
  } catch (err) {
    console.error("Failed to save supplier to Supabase:", err.message);
  }
  return saved;
};

export const deleteSupplier = async (id) => {
  const all = readCache();
  const updated = all.filter((s) => s.id !== id);
  writeCache(updated);
  
  if (!isSupabaseConfigured || !supabase) return;
  try {
    await supabase.from("suppliers").delete().eq("id", id);
  } catch (err) {
    console.error("Failed to delete supplier from Supabase:", err.message);
  }
};

